import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/core'
import {convertDatoCmsImgPathsToLocal} from '../graphql/datoCmsDataFactory'
import {getTheme, getThemeStyles} from '../util/theme'
import {getLanguageCode} from '../util/locale'

import Layout from '../components/Layout'
import Hero from '../components/Hero'

import addStartpageComToYourHomeScreenData from '../translations/add-startpage-com-to-your-home-screen.json'

const AddStartpageComToYourHomeScreen = ({languageCode}) => {
    const lang = languageCode || getLanguageCode()

    const {metaTags, contentBlocks} = addStartpageComToYourHomeScreenData[lang]
    const {title: metaTitle, description: metaDescription} = metaTags

    const [theme, setTheme] = useState('light')
    const [themeStyles, setThemeStyles] = useState({})

    useEffect(() => {
        const theme = getTheme()
        const themeStyles = getThemeStyles()
        setTheme(theme)
        setThemeStyles(themeStyles)
    }, [themeStyles])

    return (
        <Layout
            title={metaTitle}
            description={metaDescription}
            lang={lang}
            canonicalPath="/add-startpage-com-to-your-home-screen/"
            themeStyles={themeStyles}
            theme={theme}
        >
            <div
                css={css`
                    min-height: calc(100vh - 120px);
                `}
            >
                {contentBlocks && (
                    <div>
                        <Hero title={contentBlocks[0].title} body={contentBlocks[0].body} themeStyles={themeStyles} />
                        <section
                            className="iphone-instructions"
                            css={css`
                                background: ${themeStyles.lighterBackgroundColor};
                                padding: 4rem 2rem;
                                height: 845px;
                            `}
                        >
                            <div
                                css={css`
                                    max-width: 900px;
                                    margin: 0 auto;
                                    h1,
                                    li,
                                    p {
                                        color: ${themeStyles.primaryTextColor};
                                    }
                                    h1 {
                                        font-size: 2.5rem;
                                    }
                                `}
                            >
                                <h1>{contentBlocks[1].title}</h1>
                                <div
                                    css={css`
                                        ol {
                                            padding: 1rem;
                                            li {
                                                margin: 0 0 0.5rem;
                                            }
                                        }
                                    `}
                                >
                                    <ol>
                                        {contentBlocks[1].steps.map((step) => (
                                            <li>{step}</li>
                                        ))}
                                    </ol>
                                </div>
                                {contentBlocks[1].image && (
                                    <figure
                                        css={css`
                                            margin: 0;
                                            max-width: 900px;
                                            overflow: hidden;
                                        `}
                                    >
                                        <img
                                            src={convertDatoCmsImgPathsToLocal(contentBlocks[1].image.url)}
                                            alt="phone"
                                            css={css`
                                                width: 101%;
                                                display: block;
                                            `}
                                        />
                                    </figure>
                                )}
                            </div>
                        </section>
                        {contentBlocks.slice(2).map((contentBlock, i) => {
                            return (
                                <section
                                    key={i}
                                    css={css`
                                        background: ${i % 2 === 0
                                            ? themeStyles.darkerBackgroundColor
                                            : themeStyles.lighterBackgroundColor};
                                        padding: 4rem 2rem;
                                        height: 900px;
                                    `}
                                >
                                    <div
                                        css={css`
                                            max-width: 900px;
                                            margin: 0 auto;
                                            h1,
                                            li,
                                            p {
                                                color: ${themeStyles.primaryTextColor};
                                            }
                                            h1 {
                                                font-size: 2.5rem;
                                            }
                                        `}
                                    >
                                        <h1>{contentBlock.title}</h1>
                                        <div
                                            css={css`
                                                ol {
                                                    padding: 1rem;
                                                }
                                                p,
                                                li {
                                                    margin: 0 0 0.5rem;
                                                }
                                            `}
                                        >
                                            <ol>
                                                {contentBlock.steps.map((step, idx) => (
                                                    <li key={idx}>{step}</li>
                                                ))}
                                            </ol>
                                        </div>
                                        {contentBlock.image && (
                                            <img
                                                src={convertDatoCmsImgPathsToLocal(contentBlock.image.url)}
                                                alt="phone"
                                                css={css`
                                                    display: block;
                                                    margin-top: -1.5rem !important;
                                                    float: none !important;
                                                    width: 300px !important;
                                                    object-fit: contain;
                                                `}
                                            />
                                        )}
                                    </div>
                                </section>
                            )
                        })}
                    </div>
                )}
            </div>
        </Layout>
    )
}

AddStartpageComToYourHomeScreen.propTypes = {
    languageCode: PropTypes.string,
}

export default AddStartpageComToYourHomeScreen
